import { Path } from '@authority-labs/enums';

export class UploadEntity {
  name?: string;
  id: number;
  type: Path;

  constructor(type: Path, id: number, name?: string) {
    this.name = name;
    this.id = id;
    this.type = type;
  }
}
